export const PATH_PREFIX = '/ab-meble-latest'
// export const PATH_PREFIX = ''

export const DYNAMIC_IMG_REFIX = ''
